<div class="dashboard-wrapper" dir="rtl">
    <!-- FILTER -->
    <form [formGroup]="searchForm" (ngSubmit)="fetchData(true)" class="filter-section">
        <label>از تاریخ:</label>
        <ng-persian-datepicker
          [uiTheme]="'gray'"
          [timeEnable]="false"
          [dateGregorianFormat]="'YYYY/MM/DD'"
          [dateInitValue]="true"
          [dateFormat]="'jYYYY/jMM/jDD'">
          
          <input formControlName="strSDate" class="form-control text-end" dir="ltr"/>
        </ng-persian-datepicker>
        
        <label>تا تاریخ:</label>
        <ng-persian-datepicker
          [uiTheme]="'gray'"
          [timeEnable]="false"
          [dateGregorianFormat]="'YYYY/MM/DD'"
          [dateInitValue]="true"
          [dateFormat]="'jYYYY/jMM/jDD'">
          
          <input formControlName="strEDate" class="form-control text-end" dir="ltr"/>
        </ng-persian-datepicker>
        
        <button type="submit" [disabled]="searchForm.invalid"><i class="fa fa-filter"></i> اعمال فیلتر</button>
    </form>
    <!-- REPORTS -->
    <div class="report-grid">
        <div class="report-card">
            <h3><i class="fa fa-tint" style="color:#ffb74d;"></i> مصرف سوخت روزانه</h3>
            <div class="chart-wrapper"><canvas id="fuelChart"></canvas></div>
        </div>
        <div class="report-card">
            <h3><i class="fa fa-bolt" style="color:#4fc3f7;"></i> تولید انرژی روزانه</h3>
            <div class="chart-wrapper"><canvas id="energyChart"></canvas></div>
        </div>
    </div>
    <!-- SUMMARY TABLE -->
    <div class="summary-section">
        <h3><i class="fa fa-list-ul" style="color:#4caf50;"></i> خلاصه عملکرد دیزل‌ها در بازه انتخاب شده</h3>
        <div class="table-responsive" style="height: 30vh">
            <table id="summary-table" >
                <thead>
                    <tr>
                        <th>نام دیزل</th>
                        <th>مدل</th>
                        <th>برند</th>
                        <th>میانگین بار (%)</th>
                        <th>میانگین ضریب توان</th>
                        <th>کل سوخت مصرفی (لیتر)</th>
                        <th>کل انرژی تولیدی (kWh)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of summaryData">
                        <td><strong>{{ row.strName }}</strong></td>
                        <td>{{ row.strModel }}</td>
                        <td>{{ row.strBrand }}</td>
                        <td dir="ltr">{{ formatNumber(row.AvgLoadPercentage) }}</td>
                        <td dir="ltr">{{ formatNumber(row.AvgPowerFactor) }}</td>
                        <td dir="ltr">{{ formatNumber(row.TotalFuelConsumed) }}</td>
                        <td dir="ltr">{{ formatNumber(row.TotalEnergyProduced) }}</td>
                    </tr>
                    <tr *ngIf="summaryData.length === 0">
                        <td colspan="7" class="text-center" style="color: #78909c;">داده‌ای برای نمایش وجود ندارد</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
